export default {
    //namespaced: true,
    state: {
        token: '',
        userInfo: {},
        loginStatus: '',   // 登录状态
        isRoutesLoaded: false // 路由是否加载过
    },
    getters: {
    },
    mutations: {
        setUserInfo(state, data) {
            state.userInfo = data
        },
        setToken(state, data) {
            state.token = data
        },
        setLoginStatus(state, data) {
            state.loginStatus = data
        },
        setRoutesLoaded(state, data) {
            state.isRoutesLoaded = data
        },
    },
    actions: {
    }
}
